import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'create_claim',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.charges[props.index] = next
    })
  }
}
